export default "__VITE_ASSET__zPaabboa__"